import CustomDownloadChartButton from '@/components/Chart/ExportButton/CustomDownloadChartButton';
import ExportChartButton from '@/components/Chart/ExportButton/ExportChartButton';
import ExportCsvButton from '@/components/Chart/ExportButton/ExportCsvButton';
import type { ChartType } from '@/components/Chart/types/highcharts';
import ExportWidgetButton from '@/pages/Markets/MarketsComponents/components/ExportWidgetButton';
import type { BaseTabType } from '@/types/markets';

const TabExportButton = ({ tab }: { tab: BaseTabType }) => {
  if (tab.type === 'graph') {
    return tab.metadata?.graphType === 'custom' ? (
      <CustomDownloadChartButton tabName={tab.name} />
    ) : (
      <ExportChartButton
        graphType={tab.metadata?.graphType as ChartType}
        metadata={tab.metadata}
      />
    );
  }
  if (tab.type === 'csvtable') {
    return <ExportCsvButton tabName={tab.name} />;
  }
  return <ExportWidgetButton tab={tab} />;
};

export default TabExportButton;
